import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react"

import { IssueLinkWrapper } from "./Component"

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		IssueLinkNode: {
			setIssueLink: (args: { uuid: string }) => ReturnType
		}
	}
}

export const IssueLinkNode = Node.create({
	name: "IssueLinkNode",
	group: "block",
	selectable: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	addCommands() {
		return {
			setIssueLink:
				({ uuid }) =>
				({ chain }) => {
					return chain()
						.focus()
						.insertContent({
							type: this.type.name,
							attrs: { uuid: uuid },
						})
						.run()
				},
		}
	},
	parseHTML() {
		return [
			{
				tag: "issue-link",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["issue-link", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(IssueLinkWrapper)
	},
})
